export const PROFILE_TABS = [
  'overview',
  'history',
  'skins',
  'emotes',
  'preferences',
] as const;

export type ProfileTab = (typeof PROFILE_TABS)[number];

export const OWN_ONLY_TABS: ProfileTab[] = ['skins', 'emotes', 'preferences'];

export const TAB_LABELS: Record<ProfileTab, string> = {
  overview: 'Overview',
  history: 'Match History',
  skins: 'Skins',
  emotes: 'Emotes',
  preferences: 'Preferences',
};

export function parseProfileTab(
  raw: string | null,
  isOwnProfile: boolean
): ProfileTab {
  const tab = PROFILE_TABS.includes(raw as ProfileTab)
    ? (raw as ProfileTab)
    : 'overview';
  if (!isOwnProfile && OWN_ONLY_TABS.includes(tab)) return 'overview';
  return tab;
}

export function profileTabPath(displayName: string, tab: ProfileTab) {
  return `/user/${displayName}?tab=${tab}`;
}
